import { MouseEvent, KeyboardEvent, CSSProperties, ReactNode } from 'react';
import { DivProps } from './form';

interface IModalStyle {
  overlay?: CSSProperties;
  content?: CSSProperties;
}

export interface IModalBase {
  isOpen: boolean;
  onClose: (event?: MouseEvent | KeyboardEvent) => void;
  timeout?: number;
  style?: IModalStyle;
  contentLabel?: string;
  closeOnOverlayClick?: boolean;
  closeOnEsc?: boolean;
}

export interface IModalDefault extends IModalBase {
  title?: ReactNode;
  contentProps?: DivProps;
}

export interface IModalConfirm extends IModalDefault {
  onConfirm: (e: MouseEvent) => void;
  onCancel?: (e: MouseEvent) => void;
  confirmText?: string;
  cancelText?: string;
}
